import { createRouter, createWebHistory } from 'vue-router';
import LoginComponent from './components/Login.vue';
import WelcomeComponent from './components/Welcome.vue';
import VerifyComponent from './components/Verify.vue';
import HistoryComponent from './components/History.vue';

const routes = [
  {
    path: '/',
    name: 'Login',
    component: LoginComponent
  },
  {
    path: '/welcome',
    name: 'Welcome',
    component: WelcomeComponent,
    meta: { requiresAuth: true }
  },
  {
    path: '/verify',
    name: 'Verify',
    component: VerifyComponent
  },
  {
    path: '/history',
    name: 'History',
    component: HistoryComponent,
    meta: { requiresAuth: true }
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});

router.beforeEach((to, from, next) => {
  const loggedIn = localStorage.getItem('token');

  if (to.matched.some(record => record.meta.requiresAuth) && !loggedIn) {
    // Si la ruta requiere autenticación y no hay token, redirige al login
    next('/');
  } else if (to.path === '/' && loggedIn) {
    // Si el usuario está logueado e intenta ir al login, redirige a welcome
    next('/welcome');
  } else {
    next(); // Continúa a la ruta solicitada
  }
});

export default router;
